module.exports = __webpack_public_path__ + "img/container2Icon5.f6994ede.png";